import type { DocMigration } from "../docMigration";

function migratePropAttributes(propAttributes) {
  if (propAttributes.catalogItemType === "PROP_ATTRIBUTES") {
    propAttributes.catalogItemType = "PROP";
  }
  if (propAttributes.entityType === "PROP_ATTRIBUTES") {
    propAttributes.entityType = "PROP";
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_458: DocMigration = {
  maxSchemaVersion: "0.0.458",
  description: "Rename PROP_ATTRIBUTES to PROP.",
  apply(json: any): any {
    const { propAttributes, backupPropSettingsSets, entityRefs } = json;
    for (const propAttribute of Object.values(propAttributes)) {
      migratePropAttributes(propAttribute);
    }
    for (const settingsSet of Object.values(backupPropSettingsSets) as any[]) {
      if (
        (settingsSet.type === "EXTERIOR_PROP_SETTINGS" || settingsSet.type === "INTERIOR_PROP_SETTINGS") &&
        settingsSet.propTypes
      ) {
        for (const propAttribute of Object.values(settingsSet.propTypes)) {
          migratePropAttributes(propAttribute);
        }
      }
    }
    for (const entityRef of Object.values(entityRefs) as any[]) {
      if (entityRef.entityType === "PROP_ATTRIBUTES") {
        entityRef.entityType = "PROP";
      }
    }
    return json;
  },
};

export default migration_0_0_458;
